import { useEffect, useState } from 'react';
import { DEMO_DATA_REMOVED_EVENT } from './demoData';

/**
 * Chave que muda quando os dados de exemplo são removidos: o App a usa nas rotas
 * para remontar a tela atual, que recarrega sem o exemplo (sem recarregar a página).
 */
export default function useDemoDataRemovedKey() {
  const [key, setKey] = useState(0);
  useEffect(() => {
    const bump = () => setKey((value) => value + 1);
    window.addEventListener(DEMO_DATA_REMOVED_EVENT, bump);
    return () => window.removeEventListener(DEMO_DATA_REMOVED_EVENT, bump);
  }, []);
  return key;
}
